import { render, staticRenderFns } from "./ParamPopover.vue?vue&type=template&id=5f24843a&scoped=true&"
import script from "./ParamPopover.vue?vue&type=script&lang=js&"
export * from "./ParamPopover.vue?vue&type=script&lang=js&"
import style0 from "./ParamPopover.vue?vue&type=style&index=0&id=5f24843a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24843a",
  null
  
)

export default component.exports